<template>
	<v-col class="registrasi">
		<ModalTerms ref="modalTerms" :terms="dataTerms"></ModalTerms>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" :type="typeConfirm" @action="processToClone"></ModalConfirm>

		<template v-if="!loaderData">
			<div class="d-flex justify-space-between">
				<div class="text-h5 cl-primary">{{ (isPramitraReg) ? 'Registrasi Pra-Mitra' : 'Registrasi &amp; Aktivasi Mitra' }}</div>
			</div>
			<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
				<v-icon small color="grey">mdi-account-group</v-icon>
				<div class="pl-2">Jaringan</div>
				<div class="px-2">/</div>
				<div>{{ (isPramitraReg) ? 'Registrasi Pra-Mitra' : 'Registrasi &amp; Aktivasi Mitra' }}</div>
			</div>

			<div class="mt-5">
				<v-alert text dismissible class="rounded-lg mb-5" v-model="suksesInput">
					<div class="d-flex flex-wrap">
						<div>
							Selamat Anda Berhasil Mendaftarkan <strong>{{ responSuksesRegis.member_name }}.</strong>
						</div>
						<div>
							Ke <router-link to="/membership"><div classs="green--text text-underline">Daftar Prospek Mitra</div></router-link>.
						</div>
					</div>
				</v-alert>

				<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
					<div v-if="listSerialActivation">
						<!-- <v-form ref="formAddMembership" role="form"> -->
						<v-stepper
							v-model="stepForm"
							vertical
							id="registration-step"
							class="pa-0 pa-md-5"
							style="box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 12%), 0px 2px 2px 0px rgb(0 0 0 / 4%), 0px 1px 5px 0px rgb(0 0 0 / 2%);"
						>
							<!-- step 1 -->
							<template>
								<v-stepper-step
									:complete="stepForm > 1"
									step="1"
									:rules="[() => stepValid.step1]"
								>
									<span class="font-size-14">Data Jaringan &amp; Serial</span>
									<!-- <small class="d-block mt-2">Summarize if needed</small> -->
								</v-stepper-step>

								<v-stepper-content step="1">
									<v-form ref="formStep1" role="form">
										<v-row>
											<v-col cols="12" sm="5" md="5" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
													<div class="font-size-14 cl-primary">Data Jaringan</div>
													<div class="pt-2">
														<v-text-field
															label="Kode Sponsor"
															color="primary"
															hide-details="auto"
															v-model="params.sponsor_code"
															tabindex="0" ref="sponsor_code"
															:rules="rules.sponsor_code"
															@focus="$event.target.select()"
															@blur="getMitraSponsorName(params.sponsor_code, 'input')"
															:error-messages="(errorValidation !== undefined && errorValidation['sponsor_code'] !== undefined ) ? [errorValidation['sponsor_code']] : []">
														</v-text-field>
														<div class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
															{{ sponsor_name }}
														</div>
													</div>
													<template v-if="!isPramitraReg">
														<div class="pt-2">
															<v-text-field
																label="Kode Upline"
																ref="upline_code"
																color="primary"
																hide-details="auto"
																v-model="params.upline_code"
																tabindex="1"
																:rules="(isActivate) ? rules.upline_code : []"
																@focus="$event.target.select()"
																@blur="getMitraUplineName(params.upline_code, 'input')"
																:error-messages="(errorValidation !== undefined && errorValidation['upline_code'] !== undefined ) ? [errorValidation['upline_code']] : []">
															</v-text-field>
															<div class="pt-1 font-size-9" :class="(upline_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="upline_valid">
																{{ upline_name }}
															</div>
														</div>
														<div class="pt-2 pb-0 mb-1 mt-4">
															<v-card outlined dense class="py-1 px-3 mb-0 elevation-0 rounded-lg">
																<template v-if="isUplineExist">
																	<div class="d-flex flex-row">
																		<v-icon large color="grey">mdi-account-network-outline</v-icon>
																		<div class="d-flex flex-column pl-3">
																			<small>Posisi jaringan</small>
																			<template v-if="params.position == 'L'"><h4 class="cl-primary">Kiri</h4></template>
																			<template v-else-if="params.position == 'R'"><h4 class="cl-primary">Kanan</h4></template>
																			<template v-else><span class="red--text font-size-10">Anda Belum Memilih Posisi</span></template>
																		</div>
																	</div>
																</template>
																<template v-else>
																	<v-card-subtitle class="py-0 pt-2 px-0 font-weight-bold">Posisi jaringan</v-card-subtitle>
																	<v-radio-group
																		v-model="params.position"
																		ref="position"
																		row
																		hide-details="auto"
																		class="mb-2"
																		:rules="(isActivate) ? rules.position : []"
																		:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
																	>
																		<v-radio
																			label="Kiri"
																			value="L"
																			ref="positionL"
																			tabindex="2"
																		></v-radio>
																		<v-radio
																			label="Kanan"
																			value="R"
																			ref="positionR"
																		></v-radio>
																	</v-radio-group>
																</template>
															</v-card>
														</div>
													</template>
												</v-card>
											</v-col>

											<v-col cols="12" sm="5" md="5" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
													<div class="font-size-14 cl-primary">Data Serial</div>
													<div class="pt-3" v-if="params.network_serial_group !== 'basic'">
														<v-autocomplete 
															label="Serial Registrasi" 
															hide-details="auto" 
															no-data-text="Tidak ada data" 
															color="primary" 
															:items="listSerialRegis" 
															item-text="serial_member_stock_serial_id" 
															item-value="serial_member_stock_serial_id" 
															ref="membership_serial" 
															v-model="params.membership_serial" 
															:rules="(!isActivate) ? [rules.inputreq('Serial Registrasi', params.membership_serial)] : []"
															:error-messages="(errorValidation !== undefined && errorValidation['membership_serial'] !== undefined ) ? [errorValidation['membership_serial']] : []"
															tabindex="3"></v-autocomplete>
													</div>
													<template v-if="!isPramitraReg && !enableActivate">
														<!-- <div class="d-flex flex-row align-center justify-space-between font-weight-bold font-size-10 mt-2 pt-5">
															<span>Aktivasi Mitra</span>
															<v-switch
																v-model="isActivate"
																inset
																hide-details="auto"
																tabindex="3"
																style="margin-top: 0;margin-right: -8px;"
																@change="setActivateMode()"
															></v-switch>
														</div> -->
														<template>
															<div class="pt-2">
																<v-autocomplete 
																	v-model="params.network_serial"
																	:items="listSerialActivation"
																	color="primary"
																	label="Serial Aktivasi"
																	hide-details="auto"
																	item-text="id"
																	item-value="id"
																	no-data-text="Tidak ada data"
																	tabindex="4"
																	class="group-autocomplete"
																	@change="changeSerialAct(params.network_serial)"
																	:rules="[rules.inputreq('Serial Aktivasi', params.network_serial)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['network_serial'] !== undefined ) ? [errorValidation['network_serial']] : []"
																>
																	<template v-slot:selection="data">
																		<span class="gray--text lighten-5">{{ data.item.id }}</span> <span class="cl-secondary ml-2">( {{ (data.item.group == 'diamond') ? 'PLATINUM' : (data.item.group == 'basic') ? 'MIKRO' : data.item.group.toUpperCase() }} )</span>
																	</template>
																	<template v-slot:item="data">
																		<template v-if="(typeof data.item) !== 'object'">
																			<v-list-item-content v-text="data.item"></v-list-item-content>
																		</template>
																		<template v-else>
																			<v-list-item-content>
																				<v-list-item-title v-html="data.item.id"></v-list-item-title>
																			</v-list-item-content>
																		</template>
																	</template>
																</v-autocomplete>
															</div>
														</template>
													</template>
												</v-card>
											</v-col>
										</v-row>

										<v-card class="pa-3 mx-0 my-4 mx-md-2 pa-md-3 elevation-0 rounded-lg" outlined>
											<v-btn
												color="primary"
												tabindex="5"
												@click="step1Process()"
												class="d-none d-md-block"
												:loading="step1loading"
											>
												Lanjutkan
												<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
											</v-btn>

											<v-btn
												color="primary"
												tabindex="5"
												block
												@click="step1Process()"
												class="d-block d-md-none"
												:loading="step1loading"
											>
												Lanjutkan
												<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
											</v-btn>
										</v-card>
									</v-form>

								</v-stepper-content>
							</template>

							<!-- step 2 -->
							<template>
								<v-stepper-step
									:complete="stepForm > 2"
									step="2"
									:rules="[() => stepValid.step2]"
								>
									<span class="font-size-14">Data Personal</span>
								</v-stepper-step>

								<v-stepper-content step="2">
									<v-form ref="formStep2" role="form">
										<v-row>
											<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card outlined class="pa-5 d-flex flex-column elevation-0 rounded-lg fill-height">
													<v-card-title class="pa-0"><h5>Data Akun Mitra</h5></v-card-title>

													<div class="d-block mt-0 pt-0">
														<div class="d-block mb-2">
															<v-text-field
																label="Nama Lengkap"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-account"
																ref="name"
																v-model="params.name"
																tabindex="7"
																@input="params.account_name = params.name"
																:error-messages="(errorValidation !== undefined && errorValidation['name'] !== undefined ) ? [errorValidation['name']] : []"
																:rules="[rules.inputreq('Nama Mitra', params.name)]"></v-text-field>
														</div>
													</div>

													<div class="d-block mt-0 pt-0">
														<div class="d-block mb-2">
															<v-card-subtitle class="py-0 pt-2 px-0"><v-icon dense class="mr-2">mdi-account-cog-outline</v-icon>Jenis Kelamin</v-card-subtitle>
															<v-radio-group
																v-model="params.member_gender"
																row
																hide-details="auto"
																class="mb-1"
																:error-messages="(errorValidation !== undefined && errorValidation['member_gender'] !== undefined ) ? [errorValidation['member_gender']] : []"
																:rules="[rules.inputreq('Jenis Kelamin', params.member_gender)]"
															>
																<v-radio
																	label="Laki-laki"
																	value="Laki-laki"
																	tabindex="8"
																></v-radio>
																<v-radio
																	label="Perempuan"
																	value="Perempuan"
																	tabindex="9"
																></v-radio>
															</v-radio-group>
														</div>
													</div>

													<div class="d-block mb-2 pt-2">
														<v-text-field
															label="Email"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-email"
															hide-details="auto"
															v-model="params.email"
															tabindex="10"
															:error-messages="(errorValidation !== undefined && errorValidation['email'] !== undefined ) ? [errorValidation['email']] : []"
														></v-text-field>
														<!-- :rules="rules.email" -->
													</div>

													<div class="d-block mb-2 pt-2">
														<v-text-field 
															label="Password"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-key-variant"
															v-model="params.password"
															hide-details="auto"
															:type="typeInput"
															:append-icon="icon"
															@click:append="showPassword"
															tabindex="11"
															:error-messages="(errorValidation !== undefined && errorValidation['password'] !== undefined ) ? [errorValidation['password']] : []"
															:rules="rules.password"></v-text-field>
													</div>

													<div class="d-block mb-2 pt-2">
														<v-text-field
															label="Nomor KTP"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-card-account-details"
															hide-details="auto"
															v-model="params.identity_no"
															ref="identityNo"
															tabindex="12"
															maxlength="16"
															:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
															@keypress="onlyNumber"
														></v-text-field>
													</div>
															<!-- :rules="rules.noktp" -->
															<!-- @paste="validatePaste($event, 'ktp')" -->
													<div class="d-block mb-2 pt-2">
														<v-text-field
															label="Nomor Handphone"
															color="primary"
															class="input-regis"
															prepend-inner-icon="mdi-cellphone"
															v-model="params.mobilephone"
															hide-details="auto"
															tabindex="13"
															maxlength="16"
															:rules="rules.nohp"
															:error-messages="(errorValidation !== undefined && errorValidation['mobilephone'] !== undefined ) ? [errorValidation['mobilephone']] : []"
															@keypress="onlyNumber"
															@paste="validatePaste($event)"
															></v-text-field>
													</div>
												</v-card>
											</v-col>

											<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
													<v-card-title class="pa-0"><h5>Data Alamat Mitra</h5></v-card-title>
													<div class="d-block mb-0 pt-2">
														<v-textarea
															name="input-7-1"
															label="Alamat"
															v-model="params.address"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-radius-outline"
															counter="255"
															maxlenght="255"
															rows="4"
															tabindex="14"
														></v-textarea>
													</div>
													<div class="d-block mb-2 pt-0">
														<v-autocomplete
															label="Provinsi"
															no-data-text="Tidak ada data"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="provinces"
															item-text="province_name"
															item-value="province_id"
															v-model="params.province_id"
															tabindex="15"
															@change="changeProvince"></v-autocomplete>
													</div>
													<div class="d-block mb-2 pt-2">
														<v-autocomplete
															label="Kota"
															no-data-text="Pilih Provinsi Dahulu"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="cities"
															item-text="city_name"
															item-value="city_id"
															v-model="params.city_id"
															tabindex="16"></v-autocomplete>
													</div>
												</v-card>
											</v-col>

											<v-col cols="12" sm="4" md="4" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
													<v-card-title class="pa-0"><h5>Data Waris Mitra</h5></v-card-title>

													<div class="d-block mb-2 pt-2">
														<v-text-field
															label="Nama Ibu Kandung"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															v-model="params.mother_name"
															tabindex="17"></v-text-field>
													</div>
													
													<div class="d-block mb-2 pt-2">
														<v-text-field
															label="Nama Ahli Waris"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															v-model="params.devisor_name"
															tabindex="18"></v-text-field>
													</div>
													
													<div class="d-block mb-2 pt-2">
														<v-text-field
															label="Hubungan Ahli Waris"
															color="primary"
															class="input-regis"
															hide-details="auto"
															prepend-inner-icon="mdi-account"
															v-model="params.devisor_relation"
															tabindex="19"></v-text-field>
													</div>
												</v-card>
											</v-col>
										</v-row>
										
										<v-card class="d-none d-md-block pa-3 mx-0 my-4 mx-md-2 pa-md-3 elevation-0 rounded-lg" outlined>
											<v-btn text class="mr-2" @click="backStep(1)">
												<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon>
												Sebelumnya
											</v-btn>
											<v-btn
												color="primary"
												tabindex="20"
												@click="step2Process()"
											>
												Lanjutkan
												<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
											</v-btn>
										</v-card>

										<v-card class="d-block d-md-none pa-3 mx-0 my-4 mx-md-2 pa-md-3 elevation-0 rounded-lg" outlined>
											<v-btn block text class="mb-2" @click="backStep(1)">
												<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon>
												Sebelumnya
											</v-btn>
											<v-btn
												color="primary"
												block
												tabindex="20"
												@click="step2Process()"
											>
												Lanjutkan
												<v-icon dense class="ml-1">mdi-arrow-right</v-icon>
											</v-btn>
										</v-card>
									</v-form>
								</v-stepper-content>
							</template>
							
							<!-- step 3 -->
							<template>
								<v-stepper-step
									:complete="stepForm > 3"
									step="3"
								>
									<span class="font-size-14">Data Bank</span>
								</v-stepper-step>

								<v-stepper-content step="3">
									<v-form ref="formStep3" role="form">
										<v-row>
											<v-col cols="12" sm="5" md="5" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
													<div class="font-size-14 cl-primary">Informasi Rekening</div>
													<div class="pt-2">
														<v-text-field
															label="Nama Akun Rekening"
															color="primary"
															hide-details="auto"
															ref="account_name"
															prepend-inner-icon="mdi-account"
															v-model="params.account_name"
															:error-messages="(errorValidation !== undefined && errorValidation['account_name'] !== undefined ) ? [errorValidation['account_name']] : []"
															tabindex="21">
														</v-text-field>
															<!-- :rules="[rules.inputreq('Nama Akun Rekening', params.account_name)]" -->
													</div>
													<div class="pt-2">
														<v-text-field
															ref="accountNo"
															label="Nomor Rekening"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-account-box-outline"
															v-model="params.account_no"
															:error-messages="(errorValidation !== undefined && errorValidation['account_no'] !== undefined ) ? [errorValidation['account_no']] : []"
															tabindex="22"
															@keypress="onlyNumber">
														</v-text-field>
															<!-- :rules="[rules.inputreq('Nomor Rekening', params.account_no)]" -->
													</div>
													<div class="pt-2">
														<v-autocomplete
															label="Nama Bank"
															hide-details="auto"
															no-data-text="Tidak ada data"
															color="primary"
															prepend-inner-icon="mdi-bank-outline"
															:items="listBank"
															item-text="bank_name"
															item-value="bank_id"
															v-model="params.bank_id"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_id'] !== undefined ) ? [errorValidation['bank_id']] : []"
															tabindex="23"
															return-object
															@change="seletBank()">
														</v-autocomplete>
															<!-- :rules="[rules.inputreq('Nama Bank', params.bank_id)]" -->
													</div>
												</v-card>
											</v-col>

											<v-col cols="12" sm="5" md="5" class="align-stretch px-3 pt-3 px-md-5 pt-md-5">
												<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
													<div class="font-size-14 cl-primary">Informasi Lokasi Bank</div>
													<div class="pt-2">
														<v-autocomplete
															label="Provinsi Bank"
															no-data-text="Tidak ada data"
															color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="provinces"
															item-text="province_name"
															item-value="province_id"
															v-model="params.bank_province_id"
															tabindex="24"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_province_id'] !== undefined ) ? [errorValidation['bank_province_id']] : []"
															@change="changeBankProvince"></v-autocomplete>
															<!-- :rules="[rules.inputreq('Provinsi Lokasi Bank', params.bank_province_id)]" -->
													</div>
													<div class="pt-2">
														<v-autocomplete 
															label="Kota Bank"
															hide-details="auto"
															no-data-text="Pilih Provinsi Bank"
															color="primary"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="listBankCities"
															item-text="city_name"
															item-value="city_name"
															:error-messages="(errorValidation !== undefined && errorValidation['bank_city'] !== undefined ) ? [errorValidation['bank_city']] : []"
															v-model="params.bank_city"
															tabindex="25">
														</v-autocomplete>
															<!-- :rules="[rules.inputreq('Kota Lokasi Bank', params.bank_city)]" -->
													</div>
													<div class="pt-2 mb-3">
														<v-text-field
															label="Nama Cabang"
															color="primary"
															hide-details="auto"
															tabindex="26"
															prepend-inner-icon="mdi-office-building-marker-outline"
															v-model="params.bank_branch">
														</v-text-field>
													</div>
												</v-card>
											</v-col>
										</v-row>

										<v-card class="pa-3 pa-md-4 mx-0 mx-md-2 my-4 elevation-0 rounded-lg" outlined>
											<v-checkbox
												v-model="isAgreed"
												class="ma-0"
												style="margin-bottom: -15px!important;"
												tabindex="27"
												:rules="rules.input"
											>
												<template slot="label">
													<span class="d-none d-md-flex align-center">
														Saya telah membaca dan menyetujui 
														<v-btn x-small text color="primary" @click="showTerms()" class="font-weight-bold py-0 mt-1 px-1 ml-1">
															syarat &amp; ketentuan yang berlaku.
														</v-btn>
													</span>

													<span class="d-flex d-md-none flex-column">
														<span class="d-flex flex-wrap">Saya telah membaca dan menyetujui</span>
														<v-btn x-small text color="primary" @click="showTerms()" class="d-flex flex-wrap justify-start text-left font-weight-bold py-0 px-0 mt-1">
															syarat &amp; ketentuan<br>yang berlaku.
														</v-btn>
													</span>
												</template>
											</v-checkbox>
										</v-card>
									</v-form>
									
									<v-card class="d-none d-md-block pa-3 mx-0 my-4 mx-md-2 pa-md-3 elevation-0 rounded-lg" outlined>
										<v-btn text class="ml-2" @click="backStep(2)">
											<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon> Sebelumnya
										</v-btn>
									</v-card>

									<v-card class="d-block d-md-none pa-3 mx-0 my-4 mx-md-2 pa-md-3 elevation-0 rounded-lg" outlined>
										<v-btn block text class="" @click="backStep(2)">
											<v-icon dense class="mr-1">mdi-square-edit-outline</v-icon> Sebelumnya
										</v-btn>
									</v-card>
								</v-stepper-content>
							</template>
						</v-stepper>

						<v-row justify="center" class="pt-5 ml-0">
							<v-col cols="6" sm="3" md="2" class="pl-0">
								<v-btn large depressed block color="grey" class="white--text rounded-lg" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="goBack">
									<v-icon>mdi-arrow-left</v-icon>
									<span class="pl-2">Batal</span>
								</v-btn>
							</v-col>
							<v-col cols="6" sm="3" md="2" class="pl-0">
								<v-btn large depressed block class="bg-primary white--text rounded-lg" :loading="btnLoadingProses" :disabled="(isAgreed && stepForm === 3) ? false : true" tabindex="28" @click="processInput">
									<v-icon>mdi-content-save-outline</v-icon>
									<span class="pl-2">Simpan</span>
								</v-btn>
							</v-col>
						</v-row>
					</div>
				</v-scroll-x-reverse-transition>
			</div>
		</template>

		<template v-else>
			<LoadData :loading="loaderData"></LoadData>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalTerms from './components/ModalTerms'
import ModalSuccess from './components/ModalSuccess'
import ModalConfirm from './components/ModalConfirm'

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
	components: {
		ModalTerms, ModalSuccess, ModalConfirm
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			step1loading: false,
			checkbox: false,
			stepForm: 1,
			stepValid: {
				step1: true,
				step2: true,
				step3: true
			},
			typeInput: 'password',
			typeConfirm: 'confirm',
			icon: 'mdi-eye',
			page: 1,
			limit: '100',
			btnLoadingProses: false,
			suksesInput: false,
			reloadDisplay: true,
			isActivate: false,
			enableActivate: false,
			isUplineExist: false,
			isPramitraReg: false,
			isAgreed: false,
			stores_image: null,
			dataTerms: null,
			listSerialRegis: [],
			listSerialActivation: [],
			msgConfirm: '',
			sponsor_name: '',
			sponsor_valid: true,
			upline_name: '',
			upline_valid: true,
			params: {
				network_type: 'bin',
				sponsor_code: '',
				upline_code: '',
				position: '',
				membership_serial: '',
				network_serial: '',
				network_serial_group: '',
				name: '',
				identity_no: '',
				email: '',
				mobilephone: '',
				password: '',
				bank_id: '',
				bank_name: '',
				bank_branch: '',
				bank_province_id: '',
				bank_city: '',
				account_name: '',
				account_no: '',
				city_id: '',
				province_id: '',
				address: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				member_gender: 'Laki-laki'
			},
			rules: {
				input: [
					v => !!v || 'Tidak boleh kosong'
				],
				inputreq(label, v) { 
					return !!v || label + ' tidak boleh kosong'
				},
				sponsor_code: [
					v => !!v || 'Kode Sponsor tidak boleh kosong',
					v => ( v && this.sponsor_valid ) || "Data mitra tidak ditemukan",
				],
				upline_code: [
					v => !!v || 'Kode Upline tidak boleh kosong',
					v => ( v && this.upline_valid ) || "Data mitra tidak ditemukan",
				],
				position: [
					v => !!v || 'Posisi Jaringan wajib dipilih',
				],
				password: [
					v => !!v || 'Password tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "Password tidak boleh kurang dari 6 karakter",
				],
				email: [
					v => !!v || 'Email tidak boleh kosong',
					v => !!validateEmail(v) || 'Format Email tidak sesuai',
				],
				noktp: [
					v => !!v || 'Nomor KTP tidak boleh kosong',
					v => ( v && v.length >= 16 ) || "Nomor KTP tidak boleh kurang dari 16 angka",
					v => ( v && v.length <= 16 ) || "Nomor KTP tidak boleh lebih dari 16 angka",
				],
				nohp: [
					v => !!v || 'Nomor Handphone tidak boleh kosong',
					v => ( v && v.length <= 16 ) || "Nomor Handphone tidak boleh lebih dari 16 angka",
					v => ( v && v.length > 6 ) || "Nomor Handphone tidak boleh kurang dari 6 angka",
				],
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},
	watch: {
    // eslint-disable-next-line no-unused-vars
    async $route(to, from) {
			if (to.name === 'registrasi-pramitra') this.isPramitraReg = await true
			else this.isPramitraReg = await false

			if (to.query.upline !== undefined && to.query.position !== undefined) {
				this.params.upline_code = await to.query.upline
				this.params.position = await to.query.position
				this.isUplineExist = await true
				this.isActivate = await true
				if (to.query.upline) {
					this.getMitraUplineName(to.query.upline)
				} else {
					this.upline_name = await ''
					this.upline_valid = await false
				}
			} else {
				this.params.upline_code = await ''
				this.params.position = await ''
				this.isUplineExist = await false
				this.isActivate = await false
				this.upline_name = ''
				this.upline_valid = false
			}
			await this.$store.dispatch('setPageTitle', (this.isPramitraReg) ? 'Registrasi Pra-Mitra' : 'Registrasi & Aktivasi Mitra')
			await this.getData()

			setTimeout(() => {
				this.$refs.membership_serial.focus()
			}, 200);
    },

		// eslint-disable-next-line no-unused-vars
		errorValidation(newData, oldData) {
			if (newData !== undefined) {
				const step1key = ['sponsor_code', 'upline_code', 'position', 'membership_serial', 'network_serial']
				const step2key = ['name', 'identity_no', 'member_gender', 'email', 'password', 'mobilephone']
	
				const step1 = step1key.some(r=> Object.keys(newData).indexOf(r) >= 0)
				const step2 = step2key.some(r=> Object.keys(newData).indexOf(r) >= 0)
	
				if (step1) {
					this.stepForm = 1
					this.stepValid.step1 = false
				} else if (step2) {
					this.stepForm = 2
					this.stepValid.step2 = false
				} else {
					this.stepForm = 3
					this.stepValid.step3 = false
				}
			}
			
			return true
		}
  },
	computed: {
		...mapState('auth', ['userData']),
		...mapState('registration', ['mitraData', 'responSuksesRegis', 'responseError', 'errorValidation']),
		...mapState('profile', ['myProfile', 'myBank']),
		...mapState('option', ['provinces', 'cities', 'listBank', 'listBankCities']),
		...mapState('network', ['listProspek']),
	},
	methods: {
		...mapActions('serial', ['getSerialAvailable']),
		...mapActions('registration', ['getMitraByNetworkCode', 'getMitraIdentityUsed', 'addRegistration', 'addPraMitra', 'addActivation', 'resetValidation']),
		...mapActions('option', ['getProvince', 'getCity', 'getBank', 'getBankCity']),
		...mapActions('network', ['getProspekList']),

		async validatePaste(val, type){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					if (type === 'ktp') {
						val.preventDefault()
					} else {
						val.preventDefault()
					}
				}
			})
		},

		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		goBack() {
			if(this.$route.name === 'registrasi-pramitra') this.$router.push({name: 'membership'})
			else this.$router.push({name: 'genealogy'})
		},

		reset() {
			this.params = {
				network_type: 'bin',
				name: '',
				identity_no: '',
				email: '',
				mobilephone: '',
				password: '',
				bank_id: '',
				bank_name: '',
				bank_branch: '',
				bank_province_id: '',
				bank_city: '',
				account_name: '',
				account_no: '',
				city_id: '',
				province_id: '',
				address: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				member_gender: '',
				network_serial_group: ''
			}

			this.stepForm = 1
		},

		getTermContent() {
			this.dataTerms = {
				title: 'Syarat & ketentuan mitra yang berlaku',
				content: 'Belum ada konten yang tersedia.'
			}
		},

		showTerms() {
			// this.$refs.modalTerms.modalShow()
			let routeData = 'https://mjagaharu.co.id/market_plan/code_etic'
			window.open(routeData, '_blank');
		},

		changeProvince() {
			this.getCity({ province_id: this.params.province_id	})
			this.params.city_id = ''
		},

		changeBankProvince() {
			this.getBankCity({ province_id: this.params.bank_province_id	})
			this.params.bank_city = ''
		},

		setActivateMode() {
			if (this.isActivate) {
				setTimeout(() => {
					this.$refs.upline_code.focus()
				}, 200);
			} else {
				setTimeout(() => {
					this.$refs.membership_serial.focus()
				}, 200);

				// setTimeout(() => {
				// 	this.$refs.sponsor_code.focus()
				// }, 200);
			}
		},

		setSerialData(data) {
			let dataSerial = []
			var basicList = ['basic', 'mikro', 'pramitra']

			Object.keys(data).forEach((val) => {
				if (basicList.includes(this.userData.network_type)) {
					if (val == 'basic' || val == 'pramitra') {
						dataSerial.push({
							header: val.toUpperCase() + ' (' + data[val].length + ')',
						})
					}
				} else {
					if (val !== 'basic' || val !== 'pramitra') {
						dataSerial.push({
							header: ((val == 'diamond') ? 'PLATINUM' : (val == 'basic') ? 'MIKRO' : val.toUpperCase()) + ' (' + data[val].length + ')',
						})
					}
				}

				let serial = data[val]
				serial.forEach(item => {
					dataSerial.push({
						id: item.serial_member_stock_serial_id,
						group: val,
						pin: item.serial_member_stock_serial_pin,
						pv: item.serial_member_stock_serial_pv,
						stock_datetime: item.serial_member_stock_datetime,
						exp_datetime: item.serial_member_stock_expired_date,
						isExpired: item.serial_member_stock_is_expired
					})
				});
			})

			return dataSerial
		},
		
		getMitraSponsorName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						this.sponsor_name = '[' + response.data.member_name + ']'
						this.sponsor_valid = true

						if (trigger === 'input') {
							if (this.isActivate) {
								setTimeout(() => {
									this.$refs.upline_code.focus()
								}, 200);
							} else {
								setTimeout(() => {
									this.$refs.membership_serial.focus()
								}, 200);
							}
						}
					} else {
						this.sponsor_name = ''
						this.sponsor_valid = false
						setTimeout(() => {
							this.$refs.sponsor_code.focus()
						}, 200);
					}
					this.stepValid.step1 = this.$refs.formStep1.validate()
				}).catch(() => {
					this.sponsor_name = ''
					this.sponsor_valid = false
				})
			} else {
				this.sponsor_name = ''
				this.sponsor_valid = false
			}
		},

		getMitraUplineName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						this.upline_name = '[' + response.data.member_name + ']'
						this.upline_valid = true
						if (trigger === 'input' && this.$route.query.upline === undefined) {
							setTimeout(() => {
								this.$refs.positionL.$el.children[0].children[0].focus()
							}, 200);
						}
					} else {
						this.upline_name = ''
						this.upline_valid = false
						setTimeout(() => {
							this.$refs.upline_code.focus()
						}, 200);
					}
					this.stepValid.step1 = this.$refs.formStep1.validate()
				}).catch(() => {
					this.upline_name = ''
					this.upline_valid = false
				})
			} else {
				this.upline_name = ''
				this.upline_valid = false
			}
		},

		async getProspekData(id) {
			const page = await (this.$route.query.page !== undefined) ? this.$route.query.page : 0
			const limit = await (this.$route.query.limit !== undefined) ? this.$route.query.limit : 100
			await this.getProspekList(this.queryString({limit: limit, page: page}))

			const dataProspek = await this.listProspek.find(x => x.member_prospect_id === id)
			if (dataProspek) {
				this.params.name = dataProspek.member_prospect_name
				this.params.identity_no = dataProspek.member_prospect_identity_no
				this.params.email = dataProspek.member_prospect_email
				this.params.mobilephone = dataProspek.member_prospect_mobilephone
				this.params.city_id = dataProspek.member_prospect_city_id
				this.params.province_id = dataProspek.member_prospect_province_id
				this.params.address = dataProspek.member_prospect_address
				this.params.mother_name = dataProspek.member_prospect_mother_name
				this.params.devisor_name = dataProspek.member_prospect_devisor_name
				this.params.devisor_relation = dataProspek.member_prospect_devisor_relation
				this.params.member_gender = dataProspek.member_prospect_gender
				
				this.params.bank_id = dataProspek.member_prospect_bank_id
				this.params.bank_name = dataProspek.member_prospect_bank_name
				this.params.bank_branch = dataProspek.member_prospect_bank_branch
				this.params.bank_city = dataProspek.member_prospect_bank_city
				this.params.account_name = dataProspek.member_prospect_bank_account_name
				this.params.account_no = dataProspek.member_prospect_bank_account_no
			}
		},

		getData() {
			this.params.sponsor_code = this.userData.bin_network_code
			if(this.params.sponsor_code) this.getMitraSponsorName(this.userData.bin_network_code)
			this.getSerialAvailable().then((response) => {
				const data = response.results.data
				if(response) {
					this.listSerialRegis = data.registrasi
					this.listSerialActivation = this.setSerialData(data.aktivasi)
				}
			})
			this.getProvince()
			this.getCity()
			this.getBankCity()
			this.getBank()
			this.getTermContent()
		},

		handleFileUpload(event) {
			let formData = new FormData()
			formData.append('image_profile', event)
			this.Preview_image(event)
		},
		
		Preview_image(event) {
      this.stores_image= URL.createObjectURL(event)
    },

		async seletBank() {
			const selectedBank = await this.params.bank_id
			this.params.bank_id = selectedBank.bank_id
			this.params.bank_name = selectedBank.bank_name
		},

		async step1Process() {
			this.step1loading = await true
			await this.getMitraSponsorName(this.params.sponsor_code, 'submit')
			if (this.isActivate) await this.getMitraUplineName(this.params.upline_code, 'submit')

			this.stepValid.step1 = await this.$refs.formStep1.validate()

			setTimeout(() => {
				if (this.stepValid.step1) {
					this.stepForm = 2
					this.$refs.name.focus()
				} else {
					this.stepValid.step1 = false
					this.stepForm = 1
				}
				this.step1loading = false
			}, 600)
		},

		step2Process() { 
			this.stepValid.step2 = this.$refs.formStep2.validate()
			if (this.$refs.formStep2.validate()) {
				this.stepForm = 3
				this.$refs.account_name.focus()
			}
		},

		async backStep(step) {
			this.stepForm = await step
			if(step === 2) {
				this.$refs.name.focus()
			} else if (step === 1) {
				this.$refs.membership_serial.focus()
				// this.$refs.sponsor_code.focus()
			}
		},

		async savePraMitra() {
			this.btnLoadingProses = await true
			let params = await null
			params = await {
				network_type: this.params.network_type,
				sponsor_code: this.params.sponsor_code,
				membership_serial: this.params.membership_serial,
				name: this.params.name,
				mobilephone: this.params.mobilephone,
				email: this.params.email,
				identity_no: this.params.identity_no,
				password: this.params.password,
				bank_id: this.params.bank_id,
				bank_name: this.params.bank_name,
				bank_branch: this.params.bank_branch,
				bank_city: (this.params.bank_city) ? this.params.bank_city : 0,
				account_name: this.params.account_name,
				account_no: this.params.account_no,
				city_id: (this.params.city_id) ? this.params.city_id : 0,
				province_id: (this.params.province_id) ? this.params.province_id : 0,
				address: this.params.address,
				mother_name: this.params.mother_name,
				devisor_name: this.params.devisor_name,
				devisor_relation: this.params.devisor_relation,
				member_gender: this.params.member_gender
			}

			this.params.network_type = await 'bin'
			this.addPraMitra(params).then(() => {
				this.typeRegis = 'pramitra'
				this.successRegistration(this.responSuksesRegis, 'pramitra')
				this.reset()
				setTimeout(() => {
					this.btnLoadingProses = false
				}, 1000);
				// this.$router.push({name: 'membership'})
			}).catch(() => {
				this.btnLoadingProses = false
			})
		},

		async saveActivationMitra() {
			this.btnLoadingProses = await true
			let params = await null
			params = await {
				network_type: this.params.network_type,
				sponsor_code: this.params.sponsor_code,
				upline_code: this.params.upline_code,
				membership_serial: (this.params.network_serial_group !== 'basic') ? this.params.membership_serial : '',
				network_serial: this.params.network_serial,
				position: this.params.position,
				name: this.params.name,
				mobilephone: this.params.mobilephone,
				email: this.params.email,
				identity_no: this.params.identity_no,
				password: this.params.password,
				bank_id: this.params.bank_id,
				bank_name: this.params.bank_name,
				bank_branch: this.params.bank_branch,
				bank_city: (this.params.bank_city) ? this.params.bank_city : 0,
				account_name: this.params.account_name,
				account_no: this.params.account_no,
				city_id: (this.params.city_id) ? this.params.city_id : 0,
				province_id: (this.params.province_id) ? this.params.province_id : 0,
				address: this.params.address,
				mother_name: this.params.mother_name,
				devisor_name: this.params.devisor_name,
				devisor_relation: this.params.devisor_relation,
				member_gender: this.params.member_gender
			}

			this.params.network_type = await 'bin'
			this.addRegistration(params).then(() => {
				this.typeRegis = 'mitra'
				this.successRegistration(this.responSuksesRegis, 'mitra')
				this.reset()
				setTimeout(() => {
					this.btnLoadingProses = false
				}, 2000);
				// this.$router.push({name: 'genealogy'})
			}).catch(() => {
				this.btnLoadingProses = false
			})
		},

		changeSerialAct(serialId) {
			this.listSerialActivation.find(serial => {
				if (serial.id === serialId) {
          this.params.network_serial_group = serial.group
					if (serial.group == 'basic') this.params.membership_serial = ''
        }
			})
		},

		showConfirmAccount(data, type) {
			this.typeConfirm = type
			if (type === 'confirm') {
				this.msgConfirm = `
					<div class="d-block text-left mb-3">
						<span class="d-block"><span style="display: inline-block; width: 135px;">Nomor Identitas</span>: <strong class="text-capitalize">${data}</strong></span>
					</div>
					<p>Nomor Identitas ini telah terdaftar pada akun mitra anda di dalam sistem.<br>Gunakan fitur <span class="font-weight-600 text-uppercase">Kloning Akun Mitra</span> untuk menambahkan akun baru dengan nomor identitas anda.</p>
				`
			} else {
				this.msgConfirm = `
					<div class="d-block text-left mb-3">
						<span class="d-block mb-4"><span style="display: inline-block; width: 135px;">Nomor Identitas</span>: <strong class="text-capitalize">${data}</strong></span>
						<p class="mb-1" style="color: darkred;">Nomor Identitas diatas sudah terdaftar sebagai akun mitra dalam sistem. Silahkan gunakan nomor identitas yang lain.</p>
					</div>
				`
			}
			this.$refs.modalConfirm.modalShow()
		},

		cancelConfirm() {
			this.stepForm = 2
			setTimeout(() => {
				this.$refs.identityNo.$refs.input.select()
			})
		},

		processToClone() {
			this.$refs.modalConfirm.loadingButton()
			this.$router.push({name: 'cloning-mitra', query: { sponsor: this.params.sponsor_code, upline: this.params.upline_code, pos: this.params.position }})
		},

		async processInput() {
			this.stepValid.step3 = await this.$refs.formStep3.validate()
			this.btnLoadingProses = await true
			if (this.$refs.formStep3.validate()) {
				if (!this.stepValid.step1) {
					this.stepForm = 1
				} else if (!this.stepValid.step2) {
					this.stepForm = 2
				} else {
					// await this.getMitraIdentityUsed({member_identity_no: this.params.identity_no})
					// .then((response) => {
					// 	if (response.data.total > 0 && response.data.status) {
					// 		if (this.params.identity_no === this.myProfile.member_identity_no) this.typeConfirm = 'confirm'
					// 		else this.typeConfirm = 'failed'

					// 		this.showConfirmAccount(this.params.identity_no, this.typeConfirm)
					// 	} else {
							if (!this.isPramitraReg) {
								if (this.isActivate) this.saveActivationMitra()
								// else this.savePraMitra()
								else this.saveActivationMitra()
							} else {
								// this.savePraMitra()
								this.saveActivationMitra()
							}
					// 	}
					// })
					// .catch(() => {
					// 	this.btnLoadingProses = false
					// })
				}
				
				// this.btnLoadingProses = false
			} else {
				this.btnLoadingProses = false
			}
		},

		successRegistration(data, typereg) {
			if(data) {
				if (typereg === 'mitra') {
					this.msgSuccess = `
						<span class="font-weight-bold cl-primary font-size-12">Mitra Baru Anda telah berhasil di daftarkan di sistem MJA Indonesia.</span><br>
						<div class="d-block text-center my-4">
							<span class="d-block"><span style="display: inline-block;">Nama Mitra</span> : <strong>${data[0].name}</strong></span>
							<span class="d-block"><span style="display: inline-block;">Username</span> : <strong>${data[0].network_code}</strong></span>
							<span class="d-block"><span style="display: inline-block;">Password</span> : <strong>${this.params.password}</strong></span>
						</div>
						Yuk informasikan ke mitra baru Anda untuk segera login ke website <a href="https://www.mjagaharu.co.id">www.mjagaharu.co.id</a> dan segera ubah password default tersebut. Salam sukses bersama <strong>MJA Indonesia!</strong><br>
						<strong class="cl-primary">Sumber Sehat Sumber Uang...</strong>
					`
				} else {
					this.msgSuccess = `
						<span class="font-weight-bold cl-primary font-size-12">Mitra Baru Anda telah berhasil di daftarkan di sistem MJA Indonesia.</span><br>
						<div class="d-block text-center my-4">
							<span class="d-block"><span style="display: inline-block;">Nama Mitra</span> : <strong>${data.member_name}</strong></span>
							<span class="d-block"><span style="display: inline-block;">Username</span> : <strong>${data.member_email}</strong></span>
							<span class="d-block"><span style="display: inline-block;">Password</span> : <strong>${this.params.password}</strong></span>
						</div>
						Yuk informasikan ke mitra baru Anda untuk segera login ke website <a href="https://www.mjagaharu.co.id">www.mjagaharu.co.id</a>. Lakukan aktivasi & segera ubah password default tersebut. Salam sukses bersama <strong>MJA Indonesia!</strong><br>
						<strong class="cl-primary">Sumber Sehat Sumber Uang...</strong>
					`
				}

				this.resetValidation()
				this.$refs.modalSuccess.modalShow()
			}
		}
	},

	async created() {
		this.loaderData = await true
		await this.resetValidation()
		if (this.$route.name === 'registrasi-pramitra') this.isPramitraReg = await true
		else if (this.$route.name === 'registrasi-mitra') this.enableActivate = await true

		if (this.$route.query.upline !== undefined && this.$route.query.position !== undefined) {
			this.params.upline_code = await this.$route.query.upline
			this.params.position = await this.$route.query.position
			this.isUplineExist = await true
			this.isActivate = await true
			this.getMitraUplineName(this.$route.query.upline)
		}
		await this.$store.dispatch('setPageTitle', (this.isPramitraReg) ? 'Registrasi Pra-Mitra' : 'Registrasi & Aktivasi Mitra')
		await this.getData()

		if (this.$route.query.idProspek !== undefined) this.getProspekData(this.$route.query.idProspek)
		this.stepForm = await 1
		this.loaderData = false

		setTimeout(() => {
			this.$refs.membership_serial.focus()
		}, 200);
	}
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}
</style>